"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stringFunctions_1 = require("./stringFunctions");
const numberFunctions_1 = require("./numberFunctions");
const consoleFunctions_1 = require("./consoleFunctions");
exports.BuildInFunctions = Object.assign(Object.assign(Object.assign({}, stringFunctions_1.StringBuildInFunctions), numberFunctions_1.NumberBuildInFunctions), consoleFunctions_1.ConsoleBuildInFunctions);
